export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHANGE_DETAILS = "CHANGE_DETAILS";
